var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-intro"},[_c('p',{staticClass:"shop-intro__title"},[_vm._v("店铺简介")]),_c('p',{staticClass:"shop-intro__subtitle"},[_vm._v(" 一般放在装修内容下方，此模块无须预览，提供占位即可。 ")])])
}]

export { render, staticRenderFns }